import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslations } from '../../hooks/use-translations'

export const BrowserLanguageDetector: React.FC<{ redirectTo?: string }> = ({ redirectTo }) => {
  const { all } = useTranslations()
  const navigate = useNavigate()
  const browserLanguage = navigator.language
  const supportedLanguages = Object.keys(all)

  // Extract language code without region (e.g., 'en' from 'en-US')
  const languageCode = browserLanguage.split('-')[0]

  // Try exact match first, then language code without region
  const languageMatch = supportedLanguages.find(
    supportedLanguage =>
      supportedLanguage === browserLanguage || supportedLanguage === languageCode,
  )

  useEffect(() => {
    const language = languageMatch || 'en' // Fallback to English

    let path = `/${language}`

    if (redirectTo) {
      path = `${path}/${redirectTo}`
    }

    navigate(path)
  }, [])
  return <></>
}
